import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-not-found',
  templateUrl: './not-found.page.html',
  styleUrls: ['../system-error/system-error.page.scss']
})
export class NotFoundPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
